import DataGrid from '../../../../../table/DataGrid';
import FormatDate from '../../../../../date/FormatDate';

const FormLogsStatus = ({ data = [], isLoading }) => {
  return (
    <DataGrid
      showSetting={false}
      id='table-logs'
      loading={isLoading}
      columns={[
        { label: '#', key: 'index', show: true, hide: false, width: 10 },
        { label: 'date', key: 'date', show: true, hide: false },
        { label: 'status from', key: 'oldStatus', show: true, hide: false },
        { label: 'status to', key: 'newStatus', show: true, hide: false }
      ]}
      rowsPerPage={data?.length || 10}
      rows={data.map((row, index) => ({
        ...row,
        _id: new Date(row.date).getTime() + index,
        index: <p className='h-8 flex items-center text-sm'>{index + 1}</p>,
        newStatus: row.newStatus.replace(/-/g, ' ').toUpperCase(),
        oldStatus: row.oldStatus.replace(/-/g, ' ').toUpperCase(),
        date: <FormatDate date={row.date} />
      }))}
      labelNoRows="You don't have any logs yet"
    />
  );
};

export default FormLogsStatus;
